export const A11Y_SELECTOR_ATTRIBUTE = 'a11y-selector';

// ─────────────────────────────────────────────────────────────────────────────

export const A11Y_SELECTORS = {
  NAVBAR: {
    LEFT_CONTAINER: 'navbar.left-container',
    RIGHT_CONTAINER: 'navbar.right-container',
  },
  GIFT_CARDS: {
    CARDS_GRID: 'gift-cards.cards-grid',
    FILTER: 'gift-cards.filter',
    CUSTOMIZATION: {
      CONTAINER: 'gift-cards.customization.container',
      AMOUNT_OPTIONS: 'gift-cards.customization.amount-options',
      DETAILS: 'gift-cards.customization.details',
      TIME: 'gift-cards.customization.date',
      SEND_OPTION: 'gift-cards.customization.send-option',
      PAYMENT_OPTION: 'gift-cards.customization.payment-option',
      LEDGER: 'gift-cards.customization.ledger',
    },
  },
  CUSTOMIZATION: {
    CONTAINER: 'customization.container',
    NAV: 'customization.nav',
    ASIDE_PRODUCT_CONFIGURATION: 'customization.aside-product-configuration',
    ASIDE_SELECTED_INGREDIENTS_SECTION: 'customization.aside-selected-ingredients.section',
    MODIFICATION_GROUP: {
      CONTAINER: 'customization.modification-group.container',
      ITEM: 'customization.modification-group.item',
    },
  },
  LOCATIONS: {
    ORDER_CHANNEL_PICKER: {
      CONTAINER: 'locations.order-channel-picker.container',
    },
    SEARCH_FIELD: 'locations.search-field',
    MAP: {
      CONTAINER: 'locations.map.container',
    },
    RESULTS: {
      CONTAINER: 'locations.results.container',
      CONTAINER_COLLAPSED: 'locations.results.container-collapsed',
    },
    DELIVERY: {
      ADDRESSES: {
        CONTAINER: 'locations.delivery.addresses-container',
      },
    },
  },
  ACCOUNT: {
    LINKS: 'account.links',
    PROFILE: {
      CONTAINER: 'account.profile.container',
      BIRTHDAY_CONTAINER: 'account.profile.birthday-container',
    },
    PAYMENTS: {
      CONTAINER: 'account.payments.container',
      PAYMENT_METHOD_CONTAINER: 'account.payments.payment-method-container',
      GIFT_CARD_CONTAINER: 'account.payments.gift-card-container',
    },
    CREDIT_AND_PROMO: {
      CONTAINER: 'account.credit-and-promo.container',
    },
    ADDRESSES: {
      CONTAINER: 'account.addresses.container',
    },
    ORDERS: {
      CONTAINER: 'account.orders.container',
    },
    FAVORITES: {
      CONTAINER: 'account.favorites.container',
    },
    DIETARY_RESTRICTIONS: {
      CONTAINER: 'account.dietary-restrictions.container',
    },
  },
  MENU: {
    LOCATION_HEADER: 'menu.location-header',
    NAV: 'menu.nav',
    CATEGORIES_GRID: {
      CATEGORY: {
        CONTAINER: 'menu.categories-grid.category.container',
      },
    },
  },
  BAG: {
    UPSELL_PRODUCTS: {
      CONTAINER: 'bag.upsell-products.container',
      SKELETON: 'bag.upsell-products.skeleton',
    },
    HEADER: 'bag.header',
    REWARDS: {
      CONTAINER: 'bag.rewards.container',
    },
    TIME_PICKER: {
      DAY_OPTIONS: 'bag.time-picker.day-options',
      TIME_OPTIONS: 'bag.time-picker.time-options',
    },
  },
  HOME: {
    CONTAINER: 'home.container',
    HERO: {
      TEXT_CONTENT: 'home.hero.text-content',
      IMG: 'home.hero.img',
    },
  },
  LOYALTY: {
    HEADER_CONTENT: {
      CONTAINER: 'loyalty.header-content.container',
    },
    REWARDS_BAR: {
      CONTAINER: 'loyalty.rewards-bar.container',
      ITEM: 'loyalty.rewards-bar.item',
    },
    OFFERS: {
      CONTAINER: 'loyalty.offers.container',
    },
    REWARDS: {
      CONTAINER: 'loyalty.rewards.container',
    },
    FAQ: {
      CONTAINER: 'loyalty.faq.container',
    },
  },
  TAB_BAR: {
    CONTAINER: 'tab-bar.container',
  },
} as const;
